import  {jwtDecode} from 'jwt-decode';

import { Roles } from '@/common/constants';

export const verifyUserRole = (accessToken: string) => {
  const decodedToken = jwtDecode(accessToken);
  // @ts-ignore
  const role = decodedToken?.['custom:role'];
  const isLoginBlocked = role === Roles.employee || role === Roles.limitedAccess || role === Roles.noAccess;
  return isLoginBlocked;
};
